import React from "react";
import Image from 'react-bootstrap/Image';
import { Row, Col } from 'react-bootstrap';

const CartItem = ({ item, onRemoveItem, col, onUpdateQtyItem }) => {

  const imgStyle = {
    height: '30px',
    margin: 'auto',
    
  };

  const tableRowStyle = {
    border: '1px solid #fff',
  }

  const tablePriceStyle = {
    color: global.config.site.cart_sub_total_price_font_color,
  }

  const tableSubTotalStyle = {
    color: global.config.site.cart_sub_total_price_font_color,
  }

  const numStyle = {
    width: '50%',
  };
  const numTdStyle = {
    width: '20%',
  };
  const divStyle = {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  };

  const handleChange = (id, e) => {
  
    onUpdateQtyItem(id, e.target.value);
      
  };

  return (
    <>
    {col && 
      <>
        <Col className="pb-2" xs="12">
          <button className="" type="button" onClick={() => onRemoveItem(item.id)}>
              <span className="text-danger">x</span>
          </button>
        </Col>
        <Col xs="12" className="pb-2 me-auto">
          <Row>
            <Col>
            <span><b>PRODUCT:</b></span>
            </Col>
            <Col>
            <span>{item.title}</span>
            </Col>
          </Row>
           
        </Col>
        <Col className="pb-2" xs="12">
        <Row>
            <Col>
            <span ><b>PRICE:</b></span>
            </Col>
            <Col>
            <span style={tablePriceStyle}>${item.price}</span>
            </Col>
          </Row>
        </Col>
        <Col className="pb-2" xs="12">
        <Row>
            <Col>
            <span><b>QUANTITY:</b></span>
            </Col>
            <Col>
            <span><input style={numStyle} className="form-control" type="number" id="quantity" onChange={ e => handleChange(item.id, e)} value={item.qty} name="quantity" min="1" /></span>
            </Col>
          </Row>
        </Col>
        <Col className="pb-2" xs="12">
        <Row>
            <Col>
            <span><b>SUBTOTAL:</b></span>
            </Col>
            <Col>
            <span style={tableSubTotalStyle}>${item.sub_total.toFixed(2)}</span>
            </Col>
          </Row>
        </Col>
      </>
    }

    {col === undefined &&
    
      <tr style={tableRowStyle}>
        <td className="text-center">
          
          <span style={{fontSize: '26px', fontWeight: '900', textDecoration: 'none', cursor: 'pointer' }} onClick={() => onRemoveItem(item.id)} className="text-danger">x</span>
          
        </td>
        <td>
          <div style={divStyle}>
          <Image src={item.logo} style={imgStyle}></Image>
          </div>
        </td>
        <td>
          {item.title}
        </td>
        <td style={tablePriceStyle}>
          ${item.price}

        </td>
        <td style={numTdStyle}>
          <input style={numStyle} className="form-control" type="number" id="quantity" onChange={ e => handleChange(item.id, e)} value={item.qty} name="quantity" min="1" />
          
        </td>
        <td style={tableSubTotalStyle}>
          ${item.sub_total.toFixed(2)}
        </td>
      </tr>
  }
    </>
  );
};

export default CartItem;